import { Controller } from "stimulus";

export default class StepController extends Controller {
  static targets = [
    'item',
    'content',
    'prevButton',
    'nextButton',
    'submitButton'
  ];

  connect() {
    this.setIndex(0);
    this.stepSize = this.itemTargets.length;
  }

  prev(e) {
    if(this.index <= 0) { return this.index; }
    this.setIndex(this.index - 1);
    return this.index;
  }

  next(e) {
    this.setIndex(this.index + 1);
    return this.index;
  }

  setIndex(index) {
    this.index = Number(index);

    this.contentTargets.forEach(el => {
      if(el.dataset.index == this.index) {
        el.classList.add('is-active');
        return;
      }
      el.classList.remove('is-active');
    });

    this.itemTargets.forEach(el => {
      const i = Number(el.dataset.index);
      if(i < this.index) {
        el.classList.add('is-completed');
        return;
      }
      if(i == this.index) {
        el.classList.add('is-active');
        return;
      }
      el.classList.remove('is-success');
      el.classList.remove('is-active');
      el.classList.remove('is-completed');
    });

    if(this.index === 0) {
      this.prevButtonTarget.setAttribute('disabled', 'disabled');
    } else {
      this.prevButtonTarget.removeAttribute('disabled');
    }

    if(this.index === this.stepSize - 1 ) {
      this.nextButtonTarget.style.display = "none";
      this.submitButtonTarget.style.display = "";
    } else {
      this.nextButtonTarget.style.display = "";
      this.submitButtonTarget.style.display = "none";
    }
  }
}
